import React from "react";
import Navigation from "../components/site/Navigation";
import Hero from "../components/site/Hero";
import About from "../components/site/About";
import Innovation from "../components/site/Innovation";
import Products from "../components/site/Products";
import Responsibility from "../components/site/Responsibility";
import WhyChooseUs from "../components/site/WhyChooseUs";
import Contact from "../components/site/Contact";
import Footer from "../components/site/Footer";
import WhatsAppFab from "../components/site/WhatsAppFab";

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-50 font-body text-slate-900" data-testid="home-page">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Innovation />
        <Products />
        <Responsibility />
        <WhyChooseUs />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
